var __mapped = {
  __arr: []
};

export default {
  unMount: function unMount() {
    __mapped = { __arr: [] };
  },
  register: function register(name, element) {
    __mapped[name] = element;
    __mapped.__arr.push(name);
  },
  unRegister: function unRegister(name) {
    var index = __mapped.__arr.indexOf(name);
    if (index >= 0) {
      __mapped.__arr.splice(__mapped.__arr.indexOf(name), 1);
      delete __mapped[name];
    }
  },
  get: function get(name) {
    return __mapped[name];
  },
  getMapped: function getMapped() {
    return __mapped;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-scroll-anim/es/Mapped.js
// module id = 84
// module chunks = 0